import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["SLSubpageChrome"] */ "/vercel/path0/src/components/layout/SLSubpageChrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLSubpageHeaderMedia"] */ "/vercel/path0/src/components/layout/SLSubpageHeaderMedia.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLSubpageHeaderTextBlock"] */ "/vercel/path0/src/components/layout/SLSubpageHeaderTextBlock.tsx");
